import React, { useEffect, useState } from 'react'
import jwt_decode from "jwt-decode";
import Navbar from '../Navbar'
import axios from 'axios';
import baseUrl from "../BaseUrl";
import Loader from "../Loader";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import Header from '../Header';
import Select from 'react-select';
import {Bar, Line} from 'react-chartjs-2'
import DatePicker from 'react-datepicker';
import formatDateTimeToPST from "../PSTDateConvert";
import { saveAs } from 'file-saver';
import Popup from './Popup';
import PopupImage from './PopupImage';
import BatchSummaryChart from './BatchSummaryChart'; // Adjust path as needed
import 'chart.js/auto'; 
import AsyncSelect from 'react-select/async';
import {dayNameDisplay} from "../config";


const CasDashboard = () => {
    const location = useLocation();
    const { compid } = location.state || {};
    const [name, setName] = useState('');
    const [cid, setCid] = useState('')
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [error, setError] = useState(null);
    const [role, setRole] = useState('');
    const [access, setAccess] = useState([]);
    const [company, setCompany] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(compid ?? '');
    const [casAccess, setCASAccess] = useState(false);
    const [eNRMSResultTrendsAccess, setENRMSResultTrendsAccess] = useState(false);
    const [showNoAccessMessage,setShowNoMessageAccess] = useState(false)
    const [formData,setFormData] = useState({
        selectedCompany: compid ?? ''
    })
    const [ciaDetails,setCiaDetails] = useState({});
    const [ciaLastRunDetail, setCiaLastRunDetail] = useState("");
    const [ciaNextRunDetail, setCiaNextRunDetail] = useState("");
    const [graphDetails,setGraphDetails] = useState({})
    const [selectedCarrier,setSelectedCarrier] = useState(0);
    const today = new Date()
    const sixMonthsAgo = new Date(new Date().setMonth(today.getMonth() - 6));
    const [searchDate, setSearchDate] = useState(today.getFullYear() + '-' + (today.getMonth() + 1).toString().padStart(2, '0') + '-' + today.getDate().toString().padStart(2, '0'));
    const [searchEndDate, setSearchEndDate] = useState();
    const [displayDate, setDisplayDate] = useState(today);
    const [displayEndDate, setDisplayEndDate] = useState("");

    const [batchDates, setBatchDates] = useState([]);
    const [selectedBatch, setSelectedBatch] = useState(null);


    // const [trendyGraphSearchDate, setTrendyGraphSearchDate] = useState(today.getFullYear() + '-' + (today.getMonth() + 1).toString().padStart(2, '0') + '-' + today.getDate().toString().padStart(2, '0'));
    // const [trendyGrapSearchEndDate, setTrendyGraphSearchEndDate] = useState();
    // const [trendyGraphDisplayDate, setTrendyGraphDisplayDate] = useState(today);
    // const [trendyGraphDisplayEndDate, setTrendyGraphDisplayEndDate] = useState("");
    const [batchSummaryData, setBatchSummaryData] = useState([]);
    



    const [selectedNumber,setSelectedNumber] = useState('')
    const [numberGraphDetails,setNumberGraphDetails] = useState({})
    const [numberPeriodFilter,setNumberPeriodFilter] = useState('last_7_days')
    const [selectedCarrierNumber,setSelectedCarrierNumber] = useState(0)
    const [searchNumberDate, setSearchNumberDate] = useState(today.getFullYear() + '-' + (today.getMonth() + 1).toString().padStart(2, '0') + '-' + today.getDate().toString().padStart(2, '0'));
    const [searchNumberEndDate, setSearchNumberEndDate] = useState();
    const [displayNumberDate, setDisplayNumberDate] = useState(today);
    const [displayNumberEndDate, setDisplayNumberEndDate] = useState("");
    const navigate = useNavigate();
    const [viewAsCustomer, setViewAsCustomer] = useState(false);
    const [isViewAsCustomerStateInitialized, setIsViewAsCustomerStateInitialized] = useState(false);
    const [loadingCount, setLoadingCount] = useState(0);

    const [userManageTagsAccess, setUserManageTagsAccess] = useState(false);
    const [tagsList, setTagsList] = useState([]);
    const [selectedTags, setSelectedTags] = useState("");
    const [tagOperator, setTagOperator] = useState('AND');
    const [selectedNumberTags, setSelectedNumberTags] = useState("");
    const [numberTagOperator, setNumberTagOperator] = useState('AND');
    const [selectedSummaryTags, setSelectedSummaryTags] = useState("");
    const [summaryTagOperator, setSummaryTagOperator] = useState('AND');
    const [filteredNumberList, setFilteredNumberList] = useState([]);



    const incrementLoading = () => setLoadingCount((prev) => prev + 1);
    const decrementLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));

    useEffect(() => {
        refreshToken();
        getUserAccess();
        getUserCompany();
    }, []);

    useEffect(() => {
        console.log(loadingCount, "loadingCount");
        setPopupOpen(loadingCount > 0);
    }, [loadingCount]);

    // useEffect(() => {
    //     console.log(batch_id, "batch_id");
    // }, [batch_id]);


    useEffect(() => {
        // Initialize formData.selectedCompany based on role and props
        if (role > 2 && cid) { // Non-admin users get their company ID from the token
            setFormData(prev => ({...prev, selectedCompany: cid }));
        } else if (role <= 2 && compid) { // Admin users might get a company ID from navigation state
            setFormData(prev => ({...prev, selectedCompany: compid }));
        }
        // If role <= 2 (admin) and no compid is provided,
        // selectedCompany remains its initial value (compid ?? ''),
        // allowing the admin to select a company from the dropdown.
    }, [role, cid, compid]);

    // Effect 1: Initialize viewAsCustomer state from localStorage and set initialization flag
    useEffect(() => {
        if (formData.selectedCompany) {
            if (role <= 2) { // Admin-like roles who can "view as customer"
                const localStorageKey = `viewAsCustomer_${formData.selectedCompany}`;
                const storedValue = localStorage.getItem(localStorageKey);
                if (storedValue !== null) {
                    setViewAsCustomer(JSON.parse(storedValue));
                } else {
                    setViewAsCustomer(false); // Default for admin if not found in localStorage
                }
            } else { // Non-admin roles
                setViewAsCustomer(false); // Non-admins cannot view as customer
            }
            setIsViewAsCustomerStateInitialized(true); // Mark as initialized for this company/role
        } else {
            // No company selected, reset viewAsCustomer and its initialization status
            setViewAsCustomer(false);
            setIsViewAsCustomerStateInitialized(false);
        }
    }, [formData.selectedCompany, role]);

    // Effect 2: Fetch CAS access and initial batch dates (after viewAsCustomer is initialized)
    useEffect(()=>{
        if(formData.selectedCompany && token && isViewAsCustomerStateInitialized){
            // Reset CAS access status before fetching for the new company/context
            setCASAccess(false);
            setShowNoMessageAccess(false);
            
            getCustomerCASAccess(formData.selectedCompany);
            getTagsList();
            
        } else if (!formData.selectedCompany) {
            // Clear dependent states if no company is selected
            setCASAccess(false);
            setShowNoMessageAccess(false);
            setBatchDates([]);
            setSelectedBatch(null);
            setCiaDetails({});
            getTagsList();
            // Add other state resets as needed (e.g., graph data, run details)
        }
    },[formData.selectedCompany, token, isViewAsCustomerStateInitialized]); // Removed viewAsCustomer from deps

    useEffect(() => {
        if(casAccess == true && formData.selectedCompany && isViewAsCustomerStateInitialized){
            getCiaCallHistoryDate(formData.selectedCompany);
            getCiaRunDetail(formData.selectedCompany);
            
        }
    }, [casAccess, viewAsCustomer, isViewAsCustomerStateInitialized]);

    useEffect(() => {
        if(formData.selectedCompany && selectedBatch && isViewAsCustomerStateInitialized && token){
            getCiaStatistics(formData.selectedCompany, selectedBatch);
        }
    }, [formData.selectedCompany, selectedBatch, viewAsCustomer, isViewAsCustomerStateInitialized, token, selectedSummaryTags, summaryTagOperator]);
    

    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);
            
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            console.log(decoded);
            setRole(decoded.role);
            setName(decoded.name);
            setExpire(decoded.exp);
            setCid(decoded.cid)
        } catch (error) {
           
            if (error.response) {
                // setError("Unauthorized");
                navigate("/");  
                window.location.reload();
            }
        }
    }

    const getUserAccess = async () => {
        try {
            const response = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
           
            console.log(response.data.results);
            setUserManageTagsAccess(response.data.user_manage_tags == 0 ? false : true);
            setAccess(response.data.results);
            
        } catch (error) {
           console.log(error);
        }
    }

    const getUserCompany = async () => {
        
        const response = await axiosJWT.get(`${baseUrl}/active-user-company`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        console.log(response.data);
        const allArray = response.data.filter(item => item.id !== 1);
        setCompany(allArray);
    }


    const getTagsList = async () => {
        try {
            let url = `${baseUrl}/tags-list`;
            let companyIdToFetch = null;

            if (role <= 2) {
                // Admin or Super Admin: Use the filter if a company is selected
                if (formData.selectedCompany) {
                    companyIdToFetch = formData.selectedCompany;
                }
                // If no company is selected, companyIdToFetch remains null, so all tags are fetched.
            } else if (cid) {
                // Regular user: Always use their own company ID
                companyIdToFetch = cid;
            }

            if (companyIdToFetch) {
                url += `?cid=${companyIdToFetch}`;
                const response = await axiosJWT.get(url, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setTagsList(response.data.data);
            }
            
            
        } catch (error) {
            console.log(error);
        }
    };

    const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setName(decoded.name);
            setExpire(decoded.exp);
            // setCid(decoded.cid)
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    const getCiaStatistics = async (cid, batch_id) => {
        try {
            incrementLoading();
            const response = await axios.get(`${baseUrl}/get-cia-statistics/${cid}?batch_id=${batch_id}&viewAsCustomer=${viewAsCustomer}&tags=${JSON.stringify(selectedSummaryTags)}&tagOperator=${summaryTagOperator}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
           console.log(response.data);
            setCiaDetails(response.data);
            decrementLoading();
        } catch (error) {
            console.log(error);  
            decrementLoading();          
        }
    }
    
    const getCiaRunDetail = async (cid) => {
        try {
            incrementLoading();
            const response = await axios.get(`${baseUrl}/get-cia-run-detail/${cid}?viewAsCustomer=${viewAsCustomer}`,{
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            const lastRunDetail = response.data.data?.[0]?.date ?? "";
            if(lastRunDetail != ""){
                setCiaLastRunDetail(lastRunDetail);
                setSearchDate(lastRunDetail.split(" ")[0]);
                setDisplayDate(new Date(lastRunDetail));
                setSearchNumberDate(lastRunDetail.split(" ")[0]);
                setDisplayNumberDate(new Date(lastRunDetail));
            }
           
            const schedule = response.data.ciaDetail?.[0];
            let description = '';
            if(schedule){
               
                if (schedule.cia_enable_switch === 1) {
                    
                    if (schedule.occurance_type === 1) {
                        description = `Runs ${(formatDateTimeToPST(schedule.format_date, "UTC", role)).split(" ")[0]} ${schedule.one_off_time}`;
                    }else if (schedule.occurance_type === 2) {
                        if (schedule.recurring_type === 1) {
                            description = `Runs everyday`;
                            if (schedule.recurring_time) {
                              description += ` at ${schedule.recurring_time}`;
                            }
                        }else if (schedule.recurring_type === 2) {
                            description = `Runs every ${dayNameDisplay(schedule.day_of_week)}`;
                            if (schedule.recurring_time) {
                              description += ` at ${schedule.recurring_time}`;
                            }
                        }else if (schedule.recurring_type === 3) {
                            // Monthly
                            description = `Runs every  ${schedule.day_of_month} ${(schedule.day_of_month == 1 || schedule.day_of_month == 21) ? 'st' : ((schedule.day_of_month == 2 || schedule.day_of_month == 22) ? "nd" : "th")} day of month`;
                            if (schedule.recurring_time) {
                              description += ` at ${schedule.recurring_time}`;
                            }
                        } else if (schedule.recurring_type === 4) {
                            // Every X days
                            description = `Runs every ${schedule.every_x_day} day`;
                            if (schedule.recurring_time) {
                              description += ` at ${schedule.recurring_time}`;
                            }
                        } 
                        console.log(description);
                    }
                }
               
            }
            console.log(description, "description");
            setCiaNextRunDetail( description || 'No schedule defined');
            
            getGraphStatistics(formData.selectedCompany, lastRunDetail);
            getCiaTrendyGraph(formData.selectedCompany, lastRunDetail);
            decrementLoading();
        } catch (error) {
            console.log(error); 
            decrementLoading();           
        }
    }

    const getCiaCallHistoryDate = async (cid) => {
        try {
            const response = await axiosJWT.get(`${baseUrl}/get-cia-call-history-list/${cid}?viewAsCustomer=${viewAsCustomer}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
            setBatchDates(response.data.result);        
            // console.log(batch_id, "batch_id")
            // If a batch_id is passed from the previous screen, find it and set it as selected.
            // if (batch_id) {
            //     setSelectedBatch( batch_id);
            // }else{
                setSelectedBatch( response.data.result[0].id);
            // }                           
        } catch (error) {
           console.log(error);
        }
    }

 

    const getGraphStatistics = async (cid, lastRunDetail) => {
        try{
            incrementLoading();
            const start_date = lastRunDetail?.split(" ")[0] ?? searchDate;
            const response = await axios.post(`${baseUrl}/get-graph-cia-statistics/${cid}`,{carrier:selectedCarrier,fromDate:start_date,endDate:searchEndDate, viewAsCustomer: viewAsCustomer, tags: JSON.stringify(selectedTags), tagOperator: tagOperator},{
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            setGraphDetails(response.data)
            decrementLoading();
        }catch(error){
            console.log(error)
        }
    }

    const getCiaTrendyGraph = async (cid, lastRunDetail) => {
        try {
            const start_date = lastRunDetail?.split(" ")[0] ?? searchDate;
            incrementLoading();
            const response = await axios.post(`${baseUrl}/get-cia-trendy-graph/${cid}`,{fromDate:start_date,endDate:searchEndDate, viewAsCustomer:viewAsCustomer, tags: JSON.stringify(selectedTags), tagOperator: tagOperator},{
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
           console.log(response.data);
           setBatchSummaryData(response.data.trendy_graph_batches);
            decrementLoading();
        } catch (error) {
            console.log(error);  
            decrementLoading();          
        }
    }

    const getGraphStatisticsForNumber = async (number) => {
        setPopupOpen(true)
        try{
            const response = await axios.post(`${baseUrl}/get-number-graph-cia-statistics/${number}`,{id: formData.selectedCompany, carrier: selectedCarrierNumber, fromDate:searchNumberDate,endDate:searchNumberEndDate, viewAsCustomer:viewAsCustomer},{
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            setPopupOpen(false)

            console.log(response.data)
            setNumberGraphDetails(response.data)
        }catch(error){
            console.log(error)
        }
    }
    

    const getCustomerCASAccess = async (cid) => {
        try {
            incrementLoading();
            const response = await axios.get(`${baseUrl}/check-company-e911-access/${cid}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
            decrementLoading();

            if (role > 2 && (response.data.user_enms_access === 0 || response.data.cia_enable_switch === 0 || (response.data.cia_enable_switch === 1 && response.data.cia_account_type!== 1))) {
                navigate('/dashboard');
                return;
            }

            
            if(response.data.cia_enable_switch === 1){
                if(response.data.cia_account_type === 0 && role > 2){
                        setCASAccess(false)
                        setShowNoMessageAccess(true)
                }else{
                    setCASAccess(true)
                    // getCiaRunDetail(cid); // These will be triggered by their own useEffects
                    // getCiaStatistics(cid, selectedBatch); // when casAccess changes.
                    // getGraphStatistics(cid);
                    // getCiaTrendyGraph(cid);
                    setShowNoMessageAccess(false)
                }                
            }else{
                setCASAccess(false)
                setShowNoMessageAccess(true)
            }

            if(response.data.cia_enable_switch === 1 && (response.data.enrms_results_trends == 1 || role <= 2)){
                setENRMSResultTrendsAccess(true);
            }else{
                setENRMSResultTrendsAccess(false);
            }
            

        } catch (error) {
           console.log(error);
           decrementLoading();
           setCASAccess(false); // Ensure casAccess is false on error
           setShowNoMessageAccess(true); // Potentially show access message on error
        }
    };

    const handleCompanyChange = (e) => {
        setSelectedValue(e.target.value);  
        setFormData({ ...formData, selectedCompany: e.target.value });
        setSelectedCarrier(0);
        setDisplayEndDate("");
        setSearchEndDate("");
        setSelectedBatch(null);
        setNumberGraphDetails({});
        setDisplayNumberEndDate("");
        setSelectedTags("");
        setTagOperator('AND');
        setSelectedSummaryTags("");
        setSummaryTagOperator('AND');

    };

   

    const handleSelectedNumber = (data) => {
        setSelectedNumber(data.value)
    }

 
    const getCarrierName = (carrier) => {
        switch(carrier){
            case 1:
                return "T-Mobile";
            case 2:
                return "ATT"
            case 3:
                return "Verizon";
            default:
                return;
        }
    }

    const handleSearchDate = (date) => { 
        if(date){
            const formattedDate =
            date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
             date.getDate().toString().padStart(2, '0');
          
             
            setSearchDate(formattedDate);
            setDisplayDate(date);
        }
    };
    const handleSearchEndDate = (date) => { 
        const formattedDate =
        date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
         date.getDate().toString().padStart(2, '0');
      
         
        setSearchEndDate(formattedDate);
        setDisplayEndDate(date);
    }; 
    
    const handleCarrierWiseSearchSubmit = ()=> {
        getGraphStatistics(formData.selectedCompany);
        getCiaTrendyGraph(formData.selectedCompany)
    }

    // const handleTrendyGraphSearchDate = (date) => { 
    //     if(date){
    //         const formattedDate =
    //         date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
    //          date.getDate().toString().padStart(2, '0');
          
             
    //         setTrendyGraphSearchDate(formattedDate);
    //         setTrendyGraphDisplayDate(date);
    //     }
    // };
    // const handleTrendyGraphSearchEndDate = (date) => { 
    //     const formattedDate =
    //     date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
    //      date.getDate().toString().padStart(2, '0');
      
         
    //     setTrendyGraphSearchEndDate(formattedDate);
    //     setTrendyGraphDisplayEndDate(date);
    // }; 
    // const handleTrendyGraphSearchSubmit = ()=> {
    //     getCiaTrendyGraph(formData.selectedCompany)
    // }
    
    const handleNumberSearchDate = (date) => { 
        console.log(date);  
        const formattedDate =
        date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
         date.getDate().toString().padStart(2, '0');
      
         
        setSearchNumberDate(formattedDate);
        setDisplayNumberDate(date);
    };
    const handleNumberSearchEndDate = (date) => { 
        console.log(date);  
        const formattedDate =
        date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
         date.getDate().toString().padStart(2, '0');
      
         
        setSearchNumberEndDate(formattedDate);
        setDisplayNumberEndDate(date);
    };

    const handleNumberWiseSearchSubmit = ()=> {
        if(selectedNumber){
            getGraphStatisticsForNumber(selectedNumber)
        }else{
            alert("Please Select a  Telephone Number.");
            return;
        } 
    }

    const gotoCiaEnableNumber = (e, type, carrier, batch_id) => {
        e.preventDefault();
        console.log(batch_id, "data");
        navigate("/cia-number-details", { state: {compid : formData.selectedCompany, type : type, carrier : carrier, filter: true, batch_id: batch_id, tags: selectedSummaryTags, tagOperator: summaryTagOperator} })
    }

    const gotoSwitchScreen = (e, type) => {
        e.preventDefault();

        const state = { state: {compid : formData.selectedCompany, filter: false, tags: selectedSummaryTags, tagOperator: summaryTagOperator}}
        if(type == 1){
            navigate("/cia-number-details", state);
        }else if(type == 3){
            navigate("/cia-number-setting", state);
        }else if(type == 4){
            navigate("/enrms-summary-comparison", state);
        }
        // navigate("/cia-number-detail", { state: {compid : formData.selectedCompany, type : type, carrier : carrier} })
    }

    const handleViewAsCustomerChange = (event) => {
        const isChecked = event.target.checked;
        setSearchEndDate("");
        setDisplayEndDate("");
        setSearchNumberEndDate("");
        setDisplayNumberEndDate("");
        setSelectedTags("");
        setTagOperator('AND');
        setSelectedSummaryTags("");
        setSummaryTagOperator('AND');
        setViewAsCustomer(isChecked);
        
        if (formData.selectedCompany) {
            const localStorageKey = `viewAsCustomer_${formData.selectedCompany}`;
            localStorage.setItem(localStorageKey, JSON.stringify(isChecked));
        }
    };

    const handleTagsChange = (data) => {
        setSelectedTags(data);
    };

    const handleTagOperatorChange = (e) => {
        setTagOperator(e.target.value);
    };

    const handleNumberTagsChange = (data) => {
        setSelectedNumberTags(data);
    };

    const handleNumberTagOperatorChange = (e) => {
        setNumberTagOperator(e.target.value);
    };

    const handleSummaryTagsChange = (data) => {
        setSelectedSummaryTags(data);
    };

    const handleSummaryTagOperator = (e) => {
        setSummaryTagOperator(e.target.value);
    };

    useEffect(() => {
        const allNumbers = ciaDetails?.cia_enabled_numbers_list || [];
        if (!selectedNumberTags || selectedNumberTags.length === 0) {
            setFilteredNumberList(allNumbers);
            return;
        }

        const selectedTagIds = selectedNumberTags.map(t => t.value);        
        const filtered = allNumbers.filter(number => {
            if (!number.tags_id) return false;
            console.log(number.tags_id);
            const numberTagIds = String(number.tags_id)
        .split(',')
        .map(id => parseInt(id.trim(), 10));
            if (numberTagOperator === 'AND') {
                return selectedTagIds.every(tagId => numberTagIds.includes(tagId));
            } else { // OR
                return selectedTagIds.some(tagId => numberTagIds.includes(tagId));
            }
        });

        setFilteredNumberList(filtered);
        setSelectedNumber(''); // Clear selected number when filter changes
        setNumberGraphDetails({}); // Clear graph details
    }, [ciaDetails.cia_enabled_numbers_list, selectedNumberTags, numberTagOperator]);
    

  return (
    <div className="panelbox">
           <Navbar token={token} access={access}/>
            <div className="right-panel">
            <Header name={name} />
            {popupOpen && (
                     <Loader /> 
                ) }
                <div className="content-page admin-attendance-page cia-dashboard">
                    <div className="row">
                    <div className="col-4">
                        <div className="left-title">
                            <h1>E-NRMS Dashboard</h1>
                        </div>
                    </div>
                    <div className="col-8 inventory-btn">
                    
                    {/* <a href="/cas-image-texttact" className='newrow' style={{marginLeft: '10px',paddingBottom: '15px'}}>TextRact Log</a> */}
                    
                        <div className="addnew-button">
                            {/* {role <= 2 && <a href="/cas-platform-setup" style={{marginLeft: '10px',paddingBottom: '15px'}}>Setup</a>} */}
                            {eNRMSResultTrendsAccess && <a href="#" style={{marginLeft: '10px',paddingBottom: '15px'}}  onClick={(e) => gotoSwitchScreen(e, 4)}>E-NRMS Results Trends</a>}
                            <a href="#" style={{marginLeft: '10px',paddingBottom: '15px'}}  onClick={(e) => gotoSwitchScreen(e, 1)}>E-NRMS Number Details</a>
                            {/* {(role <= 2) && <a href="#" style={{marginLeft: '10px',paddingBottom: '15px'}} onClick={(e) => gotoSwitchScreen(e, 3)}>E-NRMS Enable</a>} */}
                            {/* <Link to="/cia-number-detail">E-NRMS Enabled Numbers</Link> */}
                        </div>
                    </div>
                    </div>

                    {(role <= 2) && <div className="common-white-shadow-background setting-section">
                        <div className="row">
                            <h3 className='comapny-label'>Select Company</h3>
                            <div className="inputbox">
                                <select name="" id=""  value={selectedValue} onChange={(e) => handleCompanyChange(e)}>
                                    <option value="">Select Company</option>
                                    {company.map((comp) => ( 
                                            <option key={comp.id} value={comp.id}>
                                                {comp.cname}
                                            </option>  
                                        ))}
                                </select>
                            </div>
                        </div>
                    </div>}

                    {showNoAccessMessage && 
                    <div className="common-white-shadow-background setting-section">
                        <div className="row error">You don't have access to the features.</div>
                    </div>}
                        
                    {role <= 2 && casAccess && <>
                        <div className="common-white-shadow-background setting-section">
                            <div className="settingbox">
                                <label>View as a customer</label>
                                <div className="switchbtn">
                                    <input 
                                        type="checkbox" 
                                        id="view_as_customer" 
                                        className="checkbox"  
                                        name="view_as_customer"
                                        checked={viewAsCustomer}
                                        onChange={handleViewAsCustomerChange} /> 
                                    <label htmlFor="view_as_customer" className="toggle">
                                        <p>
                                        </p>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </>}
                    {casAccess && <>
                        <div className="common-white-shadow-background setting-section">
                        <div className='row'>
                            <div><strong>Last Process Run Date & Time (UTC):</strong> {ciaLastRunDetail && formatDateTimeToPST(ciaLastRunDetail, "UTC", role)}</div>
                        </div>
                        <div className='row'>
                            <div><strong>Schedule:</strong> {ciaNextRunDetail}</div>
                        </div>
                        <div className='row'>
                            <div><strong>Total E-NRMS Enabled Numbers:</strong> {ciaDetails?.cia_enabled_numbers_count ?? ''}</div>
                        </div> 
                        </div>
                        {/* {(role <= 2) && <div className="common-white-shadow-background setting-section">
                            <div className='row'>
                                <div><strong>Total E-NRMS Enabled Numbers:</strong> {ciaDetails?.cia_enabled_numbers_count ?? ''}</div>
                            </div>
                            {ciaDetails?.cia_android_count && <><div className='row'>
                            <div className="setting-section haft-whitebox cia-table">
                                    <table className="tablebox search-result-table inventory-table">
                                        <thead>
                                            <tr>
                                                <th>Carrier</th>
                                                <th>Platform</th>
                                                <th>App - Last Active (UTC)</th>
                                                <th>App Version</th>
                                                <th>Broadcast Status</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ciaDetails?.deviceStatus.map((item, index)=>(
                                                <tr key={index}>
                                                    <td>{item.name}</td>
                                                    <td>{item.platform_type == 1 ? "Android" : "iOS"}</td>
                                                    <td>{formatDateTimeToPST(item.last_active, "UTC", role)}</td>
                                                    <td>{item.app_version ? item.app_version : "-"}</td>
                                                    <td>
                                                        <span className={item.broadcast_status == 1 ? 'success' : (item.broadcast_status == 2 ? 'error' : '')}>
                                                            {item.broadcast_status == 1 ? 'ON' : (item.broadcast_status == 2 ? "OFF" : "-")}
                                                        </span>
                                                    </td>
                                                    <td>
                                                    <span className={item.status === 'Online' ? 'success' : 'error'}>
                                                        {item.status}
                                                    </span>
                                                    </td>
                                                    
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div> </>}
                        </div>} */}
                        <div className="common-white-shadow-background setting-section">
                        
                       
                        {ciaDetails?.cia_android_count && <>
                            <div className="row align-items-center mb-3"> {/* Added mb-3 for some margin below */}
                                <div className="col-md-auto"> {/* 'auto' to take only necessary width for the label */}
                                    <h3 style={{ marginBottom: '0' }}>Caller ID Status Summary</h3> {/* Removed default h3 margin */}
                                </div>
                                <div className="col-md-2"> {/* Adjust column size as needed for the dropdown */}
                                    <select className="form-control" name='batchSelection' onChange={(e)=>{setSelectedBatch(e.target.value);}} value={selectedBatch}>
                                        {batchDates && batchDates.map((item) => (
                                            <option value={item.id} data-date={item.date}>{item.id} - {item.date.split(" ")[0]}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="boxinput col-4">     
                                {/* {userManageTagsAccess &&   <>      */}
                                                   
                                <Select
                                    classNamePrefix="select"
                                    name="tags"
                                    placeholder="Select Tag"
                                    className='search-select'
                                    onChange={(selectedOption)=>{
                                        handleSummaryTagsChange(selectedOption)
                                    }}
                                    value={selectedSummaryTags}
                                    options={ tagsList?.map(item => ({
                                        value: item.id,
                                        label: item.tag_name                                                
                                    }))}
                                    isMulti
                                    

                                />
                               
                                {selectedSummaryTags.length > 1 && (
                                    <select style={{ width: 'auto' }} className="form-control" name="tag_operator" value={summaryTagOperator} onChange={handleSummaryTagOperator}>
                                        <option value="AND">AND</option>
                                        <option value="OR">OR</option>
                                    </select>
                                )} </div>
                            </div>
                        <div className='row' style={{marginTop : '20px'}}>
                            <div><strong>Android</strong></div>
                        </div><div className="row">
                                <div className="setting-section haft-whitebox cia-table">
                                    <table className="tablebox search-result-table inventory-table">
                                        <thead>
                                            <tr>
                                                <th>Carrier</th>
                                                <th>Normal</th>
                                                <th>Spam</th>
                                                <th>Unknown</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ciaDetails?.cia_android_count.map((item, index)=>(
                                                <tr key={index}>
                                                    <td>{item.carrier_name}</td>
                                                    <td><a href="#" onClick={(e) => gotoCiaEnableNumber(e, 2, item.carrier_id, item.batch_id)}>{item.normal_count}</a></td>
                                                    <td><a href="#" onClick={(e) => gotoCiaEnableNumber(e, 1, item.carrier_id, item.batch_id)}>{item.spam_count}</a></td>
                                                    <td><a href="#" onClick={(e) => gotoCiaEnableNumber(e, 3, item.carrier_id, item.batch_id)}>{item.unknown_count}</a></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                        </div></> }
                        {ciaDetails?.cia_ios_count &&  <><div className='row' style={{marginTop : '20px'}}>
                            <div><strong>iOS</strong></div>
                        </div><div className="row">
                                <div className="setting-section haft-whitebox cia-table">
                                    <table className="tablebox search-result-table inventory-table">
                                        <thead>
                                            <tr>
                                                <th>Carrier</th>
                                                <th>Normal</th>
                                                <th>Spam</th>
                                                <th>Unknown</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ciaDetails?.cia_ios_count.map((item, index)=>(
                                                <tr key={index}>
                                                    <td>{item.carrier_name}</td>
                                                    <td><a href="#" onClick={(e) => gotoCiaEnableNumber(e, 2, item.carrier_id, item.batch_id)}>{item.normal_count}</a></td>
                                                    <td><a href="#" onClick={(e) => gotoCiaEnableNumber(e, 1, item.carrier_id, item.batch_id)}>{item.spam_count}</a></td>
                                                    <td><a href="#" onClick={(e) => gotoCiaEnableNumber(e, 3, item.carrier_id, item.batch_id)}>{item.unknown_count}</a></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                        </div></>}
                        {/* {ciaDetails?.trendy_graph &&  <><div className='row' style={{marginTop : '20px'}}>
                            <div><strong>Caller ID Status - Summary</strong></div>
                                <div className="col-md-8 ">
                                    <div className='boxinput'>
                                        <DatePicker
                                            selected={trendyGraphDisplayDate}
                                            onChange={handleTrendyGraphSearchDate}
                                            dateFormat="MM/dd/yyyy" // Set the desired date format
                                            placeholderText="From Date"
                                            className="from-date"
                                            minDate={sixMonthsAgo}
                                            maxDate={today}
                                        />
                                        <DatePicker
                                            selected={trendyGraphDisplayEndDate}
                                            onChange={handleTrendyGraphSearchEndDate}
                                            dateFormat="MM/dd/yyyy" // Set the desired date format
                                            placeholderText="To Date"
                                            className="end-date"
                                            minDate={sixMonthsAgo}
                                            maxDate={today}
                                        /> 

                                        <button className="search-btn" style={{marginLeft:'10px'}} onClick={handleTrendyGraphSearchSubmit}>Search</button>
                                    </div>
                                </div>
                        </div><div className="row">                               
                               
                            <BatchSummaryChart batchData={batchSummaryData} />
                        </div></>} */}

                        <div style={{marginTop :'50px'}}>
                        <div className="col-md-8 ">
                                <div className='boxinput'>
                                    <select className="form-control" name='carriertype' value={selectedCarrier} onChange={(e)=>{setSelectedCarrier(e.target.value)}}>
                                        <option value='0'>All</option>
                                        <option value='1'>T-Mobile</option>
                                        <option value='2'>ATT</option>
                                        <option value='3'>Verizon</option>
                                    </select>
                                    {userManageTagsAccess &&   <>                             
                                <Select
                                    classNamePrefix="select"
                                    name="tags"
                                    placeholder="Select Tag"
                                    className='search-select'
                                    onChange={(selectedOption)=>{
                                        handleTagsChange(selectedOption)
                                    }}
                                    value={selectedTags}
                                    options={ tagsList?.map(item => ({
                                        value: item.id,
                                        label: item.tag_name                                                
                                    }))}
                                    isMulti
                                    

                                />
                                {selectedTags.length > 1 && (
                                    <select style={{ width: 'auto' }} className="form-control" name="tag_operator" value={tagOperator} onChange={handleTagOperatorChange}>
                                        <option value="AND">AND</option>
                                        <option value="OR">OR</option>
                                    </select>
                                )}</>}
                                    <DatePicker
                                        selected={displayDate}
                                        onChange={handleSearchDate}
                                        dateFormat="MM/dd/yyyy" // Set the desired date format
                                        placeholderText="From Date"
                                        className="from-date"
                                        minDate={sixMonthsAgo}
                                        maxDate={today}
                                    />
                                    <DatePicker
                                        selected={displayEndDate}
                                        onChange={handleSearchEndDate}
                                        dateFormat="MM/dd/yyyy" // Set the desired date format
                                        placeholderText="To Date"
                                        className="end-date"
                                        minDate={sixMonthsAgo}
                                        maxDate={today}
                                    /> 

                                    <button className="search-btn" style={{marginLeft:'10px'}} onClick={handleCarrierWiseSearchSubmit}>Search</button>
                                </div>
                            </div>
                            </div>
                            {batchSummaryData.length > 0 && <div className='row' style={{marginTop : '20px'}}>
                            <div><strong>Caller ID Status - Summary</strong></div>
                            <div className="row">                               
                               
                               <BatchSummaryChart batchData={batchSummaryData} />
                           </div></div>}
                        <div className="row admin-staff-list-toppart" style={{marginTop :'50px'}}>
                        <h3 className='comapny-label'>Carrier Analysis</h3>
                            
                        </div>

                        { graphDetails?.android_carrier_1 && <div>
                            <StackedBarChart data={graphDetails?.android_carrier_1} carrier="T-Mobile" platform="Android" />
                        </div>
                        }
                        {graphDetails?.android_carrier_2 && <div>
                            <StackedBarChart data={graphDetails?.android_carrier_2} carrier="ATT" platform="Android" />
                        </div>
                        }
                        {graphDetails?.android_carrier_3 && <div>
                            <StackedBarChart data={graphDetails?.android_carrier_3} carrier="Verizon" platform="Android" />
                        </div>
                        }
                        { graphDetails?.ios_carrier_1 && <div>
                            <StackedBarChart data={graphDetails?.ios_carrier_1} carrier="T-Mobile" platform="iOS" />
                        </div>
                        }
                        {graphDetails?.ios_carrier_2 && <div>
                            <StackedBarChart data={graphDetails?.ios_carrier_2} carrier="ATT" platform="iOS" />
                        </div>
                        }
                        {graphDetails?.ios_carrier_3 && <div>
                            <StackedBarChart data={graphDetails?.ios_carrier_3} carrier="Verizon" platform="iOS" />
                        </div>
                        }
                        </div>
                        

                        <div className="common-white-shadow-background setting-section">
                        <div className="row">
                            <h3 className='comapny-label'>Number-based Analysis</h3>
                        </div>
                        <div className="row admin-staff-list-toppart">
                            <div className="col-md-10">
                                
                                <div className='boxinput'> 
                                    {/* <Select
                                        classNamePrefix="select"
                                        name="number"
                                        className='search-select'
                                        placeholder="Select Number"
                                        onChange={(selectedOption)=>{
                                            handleSelectedNumber(selectedOption)
                                        }}                                            
                                        options={ciaDetails?.cia_enabled_numbers_list?.map(item => ({
                                            value: item.tn_number,
                                            label: item.tn_number
                                        }))}
                                    /> */}
                                    {userManageTagsAccess &&   <>                             
                                <Select
                                    classNamePrefix="select"
                                    name="tags"
                                    placeholder="Select Tag"
                                    className='search-select'
                                    onChange={(selectedOption)=>{
                                        handleNumberTagsChange(selectedOption)
                                    }}
                                    value={selectedNumberTags}
                                    options={ tagsList?.map(item => ({
                                        value: item.id,
                                        label: item.tag_name                                                
                                    }))}
                                    isMulti
                                    

                                />
                                {selectedNumberTags.length > 1 && (
                                    <select style={{ width: 'auto', }} className="form-control" name="tag_operator" value={numberTagOperator} onChange={handleNumberTagOperatorChange}>
                                        <option value="AND">AND</option>
                                        <option value="OR">OR</option>
                                    </select>
                                )}</>}
                                    <AsyncSelect
                                        key={JSON.stringify(filteredNumberList)}
                                        classNamePrefix="select"
                                        name="number"
                                        className='search-select'
                                        placeholder="Select Number"
                                        value={selectedNumber ? { value: selectedNumber, label: selectedNumber } : null}
                                        cacheOptions
                                        defaultOptions={filteredNumberList
                                            ?.slice(0, 100)
                                            .map(item => ({
                                                value: item.tn_number,
                                                label: item.tn_number
                                            }))
                                        }
                                        loadOptions={(inputValue, callback) => {
                                            const filtered = filteredNumberList
                                                ?.filter(item =>
                                                    item.tn_number.toString().includes(inputValue)
                                                )
                                                .slice(0, 100) // Only show top 100 results
                                                .map(item => ({
                                                    value: item.tn_number,
                                                    label: item.tn_number
                                                }));
                                            callback(filtered);
                                        }}
                                        onChange={handleSelectedNumber}
                                        styles={{
                                            container: (base) => ({
                                              ...base,
                                              marginLeft: "15px"
                                            })
                                          }}
                                    />
                                    <select className="form-control" name='carriertype' value={selectedCarrierNumber} onChange={(e)=>{setSelectedCarrierNumber(e.target.value)}}>
                                        <option value='0'>All</option>
                                        <option value='1'>T-Mobile</option>
                                        <option value='2'>ATT</option>
                                        <option value='3'>Verizon</option>
                                    </select>

                                    <DatePicker
                                        selected={displayNumberDate}
                                        onChange={handleNumberSearchDate}
                                        dateFormat="MM/dd/yyyy" // Set the desired date format
                                        placeholderText="From Date"
                                        className="from-date"
                                        minDate={sixMonthsAgo}
                                        maxDate={today}
                                    />
                                    <DatePicker
                                        selected={displayNumberEndDate}
                                        onChange={handleNumberSearchEndDate}
                                        dateFormat="MM/dd/yyyy" // Set the desired date format
                                        placeholderText="To Date"
                                        className="end-date"
                                        minDate={sixMonthsAgo}
                                        maxDate={today}
                                    /> 

                                    <button className="search-btn" style={{marginLeft:'10px'}} onClick={handleNumberWiseSearchSubmit}>Search</button>
                                   
                                    {/* <select className="form-control" name="filtertypeNumber" value={numberPeriodFilter} onChange={handleNumberPeriodFilter}>
                                        <option value='last_7_days' >Last 7 Days</option>                                    
                                        <option value="last_30_days">Last 30 Days</option>
                                        <option value="last_3_month">Last 3 Month</option>
                                        <option value="last_6_month">Last 6 Month</option>
                                        <option value="last_1_year">Last 1 Year</option>
                                    </select> */}
                                </div>
                                    
                            </div>
                        </div>

                            {/* {numberGraphDetails?.cia_number_period_status_count && <div className='cia-graph-container'>
                                <LineChart period={numberPeriodFilter} data={numberGraphDetails?.cia_number_period_status_count}/>
                            </div>} */}

                            {numberGraphDetails?.cia_number_period_status_count && <div>
                                <NumberStatusLineChart data={numberGraphDetails?.cia_number_period_status_count} selectedValue={selectedValue} />
                            </div>}
                        </div>
                    </>}

                </div>
            </div>
    </div>
  )
}

export default CasDashboard



const NumberStatusLineChart = ({data, selectedValue}) => {

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupData, setPopupData] = useState(null);

    const [isPopupTwoOpen, setIsPopupTwoOpen] = useState(false);
    const [selectedDataTwo, setSelectedDataTwo] = useState(null);

    const filteredData = data.filter(entry => entry.status !== null);
    const labels = filteredData.map(entry => new Date(entry.date).toLocaleDateString('en-US',{month:'short',day:'numeric'}))
    const statusData = filteredData.map(entry => entry.status + 1)
    const chartData = {
        labels: labels,
        datasets: [
            {
              label: 'Status',
              data: statusData,
              borderColor: '#144560',
              backgroundColor: '#144560',
              fill: false,
              pointRadius: 5, // Optional: Adjust point radius
            },
          ],
    }

    const options = {
        responsive: true,
        plugins: {
          legend: {
            display: true,
            position: 'top',
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                const statusLabels = ['','Unverified', 'Verified', 'Spam'];
                return `Status: ${statusLabels[context.raw]}`;
              },
            },
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Date',
            },
            ticks: {
              autoSkip: true,
              maxTicksLimit: 10,
            },
          },
          y: {
            title: {
              display: true,
              text: 'Status',
            },
            min: 0,
            max: 4,
            stepSize: 1,
            ticks: {
              callback: function (value) {
                const statusLabels = ['','Unverified', 'Verified', 'Spam'];
                return statusLabels[value];
              },
            },
          },
        },
      };
    
    const getStatus = (status) => {
        switch (status) {
            case 1:
                return 'Normal';
            case 2:
                return 'Spam';
            default:
                return 'Unknown'
        }
    }

    const getStatusBackgroundColor = (status) => {
        switch (status) {
            case 0:
                return '#FBBC05'; // Unverified color
            case 1:
                return '#34A853'; // Verified color
            case 2:
                return '#EA4335'; // Spam color
            default:
                return '#4285F4'; // Default color if status is not recognized
        }
      };

      const openPopup = async (e, item, cid) => {
        e.preventDefault();
        console.log();
        // const cid = formData.selectedCompany
        // console.log(item.tn_number,formData.selectedCompany,item.date);
    
        const response = await axios.post(`${baseUrl}/cia-get-ftc-data-by-tn-number`, { tnNumber: item.tn_number,cid: cid, date:item.date.split(' ')[0] });
    
        console.log(response?.data?.data);
    
        setPopupData(response.data.data);
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        setPopupData(null);
    };

    const openPopupTwo = async (e, path) => {
        e.preventDefault();
        const response = await axios.post(`${baseUrl}/get-dialed-number-file`, {path});
        const { presignedUrl } = response.data;
        setSelectedDataTwo(presignedUrl);
        setIsPopupTwoOpen(true);
    };

    const closePopupTwo = () => {
        setIsPopupTwoOpen(false);
        setSelectedDataTwo(null);
    };

    return  (<div className="dialed_number_review_record">
    <div className=" setting-section haft-whitebox col-md-8">
        <table className="tablebox search-result-table inventory-table">
            <thead>
                <tr>
                    <th>Date</th>
                    <th>Carrier</th>
                    <th>Stir Shaken Attestation Audit</th>
                    <th>CNAM Audit</th>
                    <th>Scan Risk Levels</th>
                    <th>Scan FTC Report</th>
                    <th>Caller ID Status (Android) </th>
                    <th>Caller ID Status (iOS) </th>
                </tr>
            </thead>
            <tbody>
                {filteredData.map((item, index)=>(
                    <tr key={index}>
                        <td>{item.date}</td>
                        <td>{item.carrier}</td>
                        <td>{item.attestationAudit}</td>
                        <td>{item.cnam}</td>
                        <td>{item.scanRiskLevel !== null && item.scanRiskLevel !== undefined ? `Risk level : ${item.scanRiskLevel}` : ""}</td>
                        <td>{item.scanFTCReport == 1 ? <a href="#" onClick={(e) => openPopup(e, item, selectedValue)}>{(item.subject !== null ? item.subject : 'Reported')}</a> : 'Nothing Reported'}</td>
                        <td style={{ backgroundColor: getStatusBackgroundColor(item.status) }}>{(item.status == 1 || item.status == 2)  ? <a  href="#" onClick={(e) => openPopupTwo(e, item.screenshot_android)}>{getStatus(item.status)}</a> : getStatus(item.status)}</td>
                        <td style={{ backgroundColor: getStatusBackgroundColor(item.status_ios) }}>{(item.status_ios == 1 || item.status_ios == 2)  ? <a  href="#" onClick={(e) => openPopupTwo(e, item.screenshot_ios)}>{getStatus(item.status_ios)}</a> : getStatus(item.status_ios)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
    {isPopupOpen && <Popup data={popupData} onClose={closePopup} />}
    {isPopupTwoOpen && <PopupImage data={selectedDataTwo} onClose={closePopupTwo} />}
    </div>)

}


const StackedBarChart = ({data, carrier, platform})=> {
    const labels = data.map(entry => new Date(entry.date).toLocaleDateString('en-US',{month:'short',day:'numeric', timeZone: 'UTC'}))
    const normalCounts = data.map(entry => entry.normal_count);
    // const unverifiedCounts = data.map(entry => entry.unverified_count);
    const spamCounts = data.map(entry => entry.spam_count);
    const unknownCounts = data.map(entry => entry.unknown_count);
    
    const chartData = {
        labels: labels,
        datasets:[
            {
                label: 'Normal',
                data: normalCounts,
                backgroundColor: '#34A853',
                borderColor: '#34A853',
                borderWidth: 1,
            },
            // {
            //     label: 'Unverified',
            //     data: unverifiedCounts,
            //     backgroundColor: '#FBBC05',
            //     borderColor: '#FBBC05',
            //     borderWidth: 1,
            // },
            {
                label: 'Spam',
                data: spamCounts,
                backgroundColor: '#EA4335',
                borderColor: '#EA4335',
                borderWidth: 1,
            },
            {
                label: 'Unknown',
                data: unknownCounts,
                backgroundColor: '#4285F4',
                borderColor: '#4285F4',
                borderWidth: 1,
            }
        ]
    }

    const isSingleDataset = data.length < 3;
    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: `Caller ID Status - ${carrier} (${platform})`
            },
        },
        scales: {
            x: {
                stacked: true,
                title: {
                    display: true,
                    text: 'Date',
                },
            },
            y: {
                stacked: true,
                title: {
                    display: true,
                    text: 'Count',
                },
                beginAtZero: true,
            },
        },
        barThickness:  isSingleDataset ? 100 :"flex",
        maxBarThickness: isSingleDataset ? 100 :undefined ,
    };


    return <>
        <Bar data={chartData} options={options} />
    </>
}